import React from 'react';
import { T } from '../../../../../common/locale/translate';

const WhyFromGermanyLink = ({ className, link }) => (
  <a
    className={`why-from-germany-link ${className ? className : ''}`}
    href={link}
    title={T('why_from_germany_link_title')}
  >
    {`${T('why_from_germany')} `}
    <span className="arrow fa fa-chevron-right" />
  </a>
);

export default WhyFromGermanyLink;



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/why_from_germany_link.jsx